function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M3.5 22.167v-7.58a1.75 1.75 0 012.814-1.39l6.268 4.8c.837.64 2 .64 2.837 0l6.267-4.8a1.75 1.75 0 012.814 1.39v7.58a2.333 2.333 0 01-2.333 2.333H5.833A2.333 2.333 0 013.5 22.167z",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.167 12.934V4.667a2.333 2.333 0 00-2.334-2.333H8.167a2.333 2.333 0 00-2.334 2.333v8.267M14 14.583v-1.166",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.667 8.167v0c0 .746.527 1.388 1.258 1.535l2.15.43a1.565 1.565 0 011.258 1.535v0M16.333 11.667c0 .966-1.044 1.75-2.333 1.75a2.38 2.38 0 01-2.19-1.167M16.181 7.56a2.393 2.393 0 00-2.18-1.143c-1.29 0-2.334.783-2.334 1.75M14 5.25v1.167",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));